import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { SharedFeatureEditPersonaModalModule } from '@se-po/shared-feature-edit-persona-modal'
import { SharedUiAddChildContactInfoModule } from '@se-po/shared-ui-add-child-contact-info'
import { SharedUiAddChildProfileModule } from '@se-po/shared-ui-add-child-profile'
import { SharedUiPersonaPickerModule } from '@se-po/shared-ui-persona-picker'
import { SeFeChipModule } from 'se-fe-chip'
import { SeFeIconModule, seFeIconPlusCircleOutline } from 'se-fe-icon'
import { SeFeModalModule } from 'se-fe-modal'
import { SeFeToastModule } from 'se-fe-toast'

import { PersonaPickerComponent } from './persona-picker/persona-picker.component'

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    SeFeChipModule,
    SeFeModalModule,
    SeFeIconModule.include([
      seFeIconPlusCircleOutline
    ]),
    SeFeToastModule,
    SharedFeatureEditPersonaModalModule,
    SharedUiAddChildContactInfoModule,
    SharedUiAddChildProfileModule,
    SharedUiPersonaPickerModule,
  ],
  declarations: [PersonaPickerComponent],
  exports: [PersonaPickerComponent],
})
export class SePersonaPickerFeaturePersonaPickerModule { }
